//********************************
//SWIPEBOX
//********************************
jQuery(document).ready(function($){
	
    if ($.fn.swipebox){
		//From theme settings
		if (wpk_script_object.swipebox === '1') {

			//Add swipebox on all regular images in site
			//Add rel group on all images for grouping in swipebox
			$('.wp-block-gallery a[href$=".gif"], .wp-block-gallery a[href$=".jpg"], .wp-block-gallery a[href$=".png"]').addClass('wpk-swipebox zoom-in img-rollover').attr('rel', 'group');

			//Add rel with unique id to Gallery image links. (overrides above rel. Must come after)
			//This feature groups images for every gallery when there is multiple galleries on same page
			$('.wp-block-gallery').each(function(i){
				$(this).find('a').attr('rel', 'gallery-' + i);
			 }); 

			//Add swipebox funtionality
			$('.wpk-swipebox').swipebox({
				//Show arrows on mobile
                removeBarsOnMobile : false
			});

		}
	}
    
}); //End jQuery

